<template>
  <div style="margin: 0 auto; max-width: 610px">
    <div class="p-4">
      <h2 class="form-title">Novos horários</h2>
      <NewSlotSimpleForm />
    </div>
  </div>
</template>

<script>
import NewSlotSimpleForm from "../components/NewSlotSimpleForm.vue";
export default {
  components: {
    NewSlotSimpleForm
  }
};
</script>

<style></style>
